export default "__VITE_ASSET__WFfC0775GI2z1wig8lWzrg__";